export enum PlCategoryType {
    netRevenues = 'Net Revenues',
	totalExpenses = 'Total Expenses',
    additionalInformation = 'Additional Information'
}